module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e39",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "d0e39",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e39",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e39",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e39",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("In this volume, my intention is to present you, the reader, with portraits of the most\n        entrancing vegetables on the planet. Alluring vegetables. Enticing vegetables. Heirloom and\n        hybrid. Native and transplant. Seventy-five really superb vegetables in current culture that\n        are as exciting for their physical beauty as they are for their taste. Originating in every\n        corner of the globe and possessed of a savor and an aesthetic charm that would make the\n        loveliest blossoms hang their head, these are vegetables with which every serious gardener\n        should be acquainted.")]), _vm._v(" "), _c('p', [_vm._v("That said, I have defiantly stretched the boundaries of both cultivation and cultivar in\n        this volume to include some vegetable varieties that will definitely need to be started\n        indoors in most American climates, and others that are not really vegetables at all, but\n        fruits (tomatoes, eggplants) or berries (melons). Ultimately, my definitions on both of\n        these fronts grew to include anything I happen to grown in my own kitchen garden and,\n        certainly, like Webster’s and the United States Supreme Court, we can broaden the definition\n        of the word ” to include any plant “grown for an edible part...usually eaten with the\n        principal part of a meal.”")]), _vm._v(" "), _c('p', [_vm._v("You will also note that, in introducing these vegetables alphabetically, I have chosen,\n        rather willy-nilly, to list some by species and others by variety. This had as much to do\n        with the resultant “mix” of plants and information as it did with botanical accuracy. I have\n        also purposefully steered away from glossy photographs and a larger scale design to give you\n        a small, illustrated book that, hopefully, has the charm, decorativeness, and durability of\n        those wonderful, informative books of the past, which sought to enlighten and amuse as they\n        instructed. In all these things, I heartily hope that I have succeeded to the reader’s\n        satisfaction. I wish you abundant harvest and excellent dining along the way!")]), _vm._v(" "), _c('p', [_vm._v("—Jack Staub")]), _vm._v(" "), _c('p', [_vm._v("Hortulus Farm")])])]), _c('a', {
    attrs: {
      "id": "d0e39",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c97806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 69
// module chunks = 0